export function getCookie(name, defaultValue, { json = false } = {}) {
  if (!name) {
    return undefined;
  }

  let matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()\[\]\\\/+^])/g, '\\$1') + '=([^;]*)'));
  if (matches) {
    let res = decodeURIComponent(matches[1]);

    if (res === 'true') return true;
    if (res === 'false') return false;

    if (json) {
      try {
        return JSON.parse(res);
      } catch (e) {}
    }

    return res;
  }
  return defaultValue;
}

export function setCookie(
  name,
  value,
  options = {
    path: '/'
  }
) {
  if (!name) {
    return;
  }
  options = options || {};

  // Установить срок действия по умолчанию на 7 дней, если не задано
  if (!options.expires) {
    const date = new Date();
    date.setDate(date.getDate() + 7); // Добавляем 7 дней
    options.expires = date.toUTCString();
  } else if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  if (value instanceof Object) {
    value = JSON.stringify(value);
  }

  let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);
  for (let optionKey in options) {
    updatedCookie += '; ' + optionKey;
    let optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += '=' + optionValue;
    }
  }

  document.cookie = updatedCookie;
}

export function deleteCookie(name) {
  setCookie(name, null, {
    expires: new Date(),
    path: '/'
  });
}
